import { MenuUsuario } from "./menu/MenuUsuario";
import { useParams } from "react-router-dom";
import { Projects } from "../devops/Projects";
import { StepDevops } from "../devops/StepDevops";
import { RolDevops } from "../devops/RolDevops";
import { AccountProject } from "../devops/AccountProject";
import { History } from "../devops/History";
import { BudgetStructure } from "./configuracion/BudgetStructure";
import { FunctionalID } from "./configuracion/functionalID/FunctionalID";
import { Components } from "../devops/Components";
import { MatrizSeguimiento } from "../devops/MatrizSeguimiento";
import { ProjectID } from "./configuracion/ProjectID/ProjectID";
import { UnspscID } from "./configuracion/UnspscID/UnspscID";
import { BudgetID } from "./configuracion/BudgetID/BudgetID";
import { BasicPage } from "../theme/Component/BasicPage";
import { ApiModule } from "./api/ApiModule";
import { ApiRole } from "./api/ApiRole";
import { SystemRoles } from "./Roles/SystemRoles";
import { TrdID } from "./configuracion/TrdID/TrdID";
import { RequirementType } from "../contract/RequirementType";
import { HiringModalityDocument } from "../contract/HiringModalityDocument";
import { BudgetIDType } from "./configuracion/BudgetIDType";
import { BudgetType } from "./configuracion/BudgetType";
import { SystemPropertie } from "./configuracion/SystemProperties";
import { AbstractAccount } from "./configuracion/AbstractAccount";
import { StructuringDocument } from "../contract/StructuringDocument";
import { MeasurementUnit } from "./configuracion/MeasurementUnit";
import { DeliveryType } from "./configuracion/DeliveryType";
import { AuditLog } from "./audit/AuditLog";
import { PgpEncrypt } from "../../core/secure/Pgp/PgpEncrypt";
import { SuppConstants } from "../bpm/config/Componentes/SuppConstants";
import { RequirementSST } from "../bpm/config/Componentes/RequirementSST";
import { Matrizriesgos } from "../bpm/config/Componentes/Matrizriesgos";
import { DocSupplierConfig } from "../bpm/config/Componentes/DocSupplierConfig";
import { MisApprovals } from "../approval/MisApprovals";
import { FestiveDay } from "./utils/FestiveDay";
import { ApplicationGroup } from "./applicationGroup/ApplicationGroup";
import { Formatos } from "../bpm/config/Componentes/Formatos";
import { FactorMatrix } from "../bpm/config/Componentes/FactorMatrix";
import { Auditorianueva } from "../contract/auditoria/Auditorianueva";
import { ErrorsSql } from "../contract/auditoria/ErrorrsSql";
import { ThirdPartyUser } from "./ThirdPartyUser/ThirdPartyUser";
import { Afiliate } from "./Afiliados/Afiliate";
import { SalaryInquiry } from "../adminServices/SalaryInquiry";
import { DocumentTemplate } from "./plantillas/DocumentTemplate";
import { GenericCellEditor } from "./generic-editor/GenericCellEditor";
import { ExportMenu } from './menu/ExportMenu';
import { EducationalSupport } from "../Talentohumano/payRoll/EducationalSupport";
import { EnjoyedVacationERP } from "../Talentohumano/payRoll/EnjoyedVacationERP";
import { GroupTemplate } from "../bpm/config/Componentes/GroupTemplate";
import { Historialdetramite } from "../bpm/config/Historialtramites";
import { VisualBandeja } from "./perfil/VisualBandeja";
import { ReaderUHF } from "./configuracion/UHFReader/ReaderUHF";
import { Company } from "../erp/cellEditor/Company/Company-component";
import { AccountantBook } from "../erp/cellEditor/AccountantBook/AccountantBook-component";
import { Office } from "../erp/cellEditor/Office/Office-component";
import { Currency } from "../erp/cellEditor/Currency/Currency-component";
import { InboxCash } from "../erp/cellEditor/CashDesk/InboxCash-component";
import { FormType } from "../custom/forpo/components/GenericForms&Constants/FormType.advantage";
import { CashDeskAccount } from "../erp/cellEditor/CashDeskAccount/CashDeskAccount-component";
import { Miscursos } from "../Talentohumano/CurseConfig/Miscursos";
import { RoleGroup } from "./RolesGroup/RoleGroup";
import { RoleArea } from "./RolesArea/RoleArea";
import { AccountantIDType } from "../contabilidad/catalogo-cuentas/AccountantIDType";
import { ImportarCuentasContables } from "../contabilidad/catalogo-cuentas/ImportarCuentasContables";
import { AccountantTree } from "../contabilidad/catalogo-cuentas/AccountantTree/AccountantTree";
import { ExportarCuentasContables } from "../contabilidad/catalogo-cuentas/ExportarCuentasContables";
import { CashReimbursementHistory } from "../erp/cellEditor/CashDesk/CashReimbursement/CashReimbursementHistory";
import { TaxSchemeContext } from "./ConfImpuestos/TaxSchemeCode/TaxSchemeContext";
import { UBLTaxSchemeContextCode } from "./ConfImpuestos/UBLTaxScheme/UBLTaxSchemeContextCode";
import { AccountantConcept } from "../erp/cellEditor/AccountantConcept/AccountantConcept";
import { FiscalResponsabilityType } from "../erp/FiscalResponsabilityType/FiscalResponsabilityType";
import { FiscalResponsability } from "../erp/FiscalResponsability/FiscalResponsability";
import { TaxScheme } from "./ConfImpuestos/TaxScheme/TaxScheme";
import { ContractRole } from "./configuracion/ContractRole";
import { RequestTypeBpm } from "./configuracion/RequestTypeBPM/RequestTypeBpm";
import { FunctionalArea } from "./configuracion/FunctionalArea/FunctionalArea";
import { PaymentType } from "../erp/cellEditor/PaymentType/PaymentType";
import { BankingEntity } from "../erp/cellEditor/BankingEntity/BankingEntity";
import { ThirdBankingAccount } from "../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBankingAccount";
import { BankAccountCatalog } from "../erp/cellEditor/BankAccount/BankAccount";
import { TaxCodeAccount } from "../Talentohumano/ParametrosTalentoHumano/TaxCodeAccount/TaxCodeAccount";
import { CashReimbursementConcept } from "../Talentohumano/CajasMenoresConceptos/CashReimbursementConcept";
import { TaxCodeScheme } from "./ConfImpuestos/TaxCodeScheme/TaxCodeScheme";
import { TaxCode } from "./ConfImpuestos/TaxCode/TaxCode";
import { MeasurementUnitCode } from "../erp/MeasurementUnitCode/MeasurementUnitCode";
import { CostingCenter } from "../erp/cellEditor/CostingCenter/CostingCenter";
import { ArticleClassType } from "../erp/ArticleClassType/ArticleClassType";
import { PaymentRequirement } from "./configuracion/PaymentRequirement";
import { ContractType } from "./configuracion/ContractType";
import { ArticleClassCodeTree } from "../contabilidad/catalogo-bienes/ArticleClassCodeTree";
import { AdquisitionProject } from "../erp/AdquisitionProject/AdquisitionProject";
import { TaxSchemeSimulator } from "./ConfImpuestos/TaxScheme/FuncionesTaxScheme/TaxSchemeSimulator";
import { TabsCourse } from "../Talentohumano/CurseConfig/TabsCourse";
import { FunctionalAreaVdos } from "../erp/FunctionalArea/FunctionalArea";
import { BudgetAccountantID } from "../erp/BudgetAccountantID/BudgetAccountantID";
import { PaymentAccount } from "../Talentohumano/GestionTH/PaymentAccount/PaymentAccount";
import { PaymentMethod } from "../Talentohumano/PaymentMethod/PaymentMethod";
import { BudgetResource } from "./configuracion/BudgetResource/BudgetResource";
import { CashRequest } from "../erp/cellEditor/CashRequest/CahsRequest";
import { ManageCahsRequest } from "../erp/cellEditor/CashRequest/ManageCahsRequest";
import { BudgetSource } from "./configuracion/BudgetSource/BudgetSource";
import { BudgetRPFactory } from "../contabilidad/budgetRPFactory/BudgetRPFactory";
import { BodegaDocumentos } from "../contabilidad/bodegaDocumentos/BodegaDocumentos";
import { BudgetObligationFactory } from "../contabilidad/budgetObligationFactory/BudgetObligationFactory";
import { BudgetSheetFactory } from "../contabilidad/BudgetSheetFactory/BudgetSheetFactory";
import { BudgetAdditionFactory } from "../contabilidad/BudgetAdditionFactory/BudgetAdditionFactory";
import { BudgetReductionFactory } from "../contabilidad/BudgetReductionFactory/BudgetReductionFactory";
import { BudgetCDPReductionFactory } from "../contabilidad/BudgetCDPReductionFactory/BudgetCDPReductionFactory";
import { BudgetMovementFactory } from "../contabilidad/BudgetMovementFactory/BudgetMovementFactory";
import { BudgetReductionRPFactory } from "../contabilidad/BudgetReductionRPFactory/BudgetReductionRPFactory";
import { BudgetAccountantOperation } from "../erp/cellEditor/BudgetAccountantOperation/BudgetAccountantOperation";
import { BusinessCore } from "../erp/cellEditor/BusinessCore/BusinessCore";
import { DocumentType } from "../erp/DocumentType/DocumentType";
import { Process } from "../erp/Process/Process";
import { TypeNeed } from "../erp/TypeNeed/TypeNeed";
import { UBLDocumentCatalog } from "../contabilidad/CatalogoDocumentosUBL/UBLDocumentCatalog";
import { UBLSoftwareDispatcher } from "../Talentohumano/GestionTH/UBLSoftwareDispatcher/UBLSoftwareDispatcher";
import { Certificate } from "../Talentohumano/GestionTH/CertificateDigital/Certificate";
import { ImportBankingAccount } from "./parametros/ImportBankingAccount";
import { EmployeeContractByIDLN } from "../Talentohumano/GestionTH/EmployeeContract/EmployeeContractByIDLN";
import { PerosnalInbox } from "../bpm/PersonaInbox/Personalnbox";
import { CashDeskAccountCDP } from "../erp/cellEditor/CashDeskAccount/CashDeskAccountCDP/CashDeskAccountCDP";
import { RolesenArea } from "../Talentohumano/RolesenArea/RolesenArea";
import { SignAndApprovalPanel } from "../contabilidad/SignAndApprovalPanel/SignAndApprovalPanel";
import { CustomProcessType } from "../erp/cellEditor/CustomProcessType/CustomProcessType";
import { BudgetCDPFactory } from "../contabilidad/BudgetCDPFactory/BudgetCDPFactory";
import { PaymentHeader } from "../erp/cellEditor/PaymentHeader/PaymentHeader";
import { DodoPanel } from "../contract/etapa-contrato/contrac/Dodo/DodoPanel";
import { PdfLibraryFactory } from "./configuracion/functionalID/PdfLibraryFactory";
import { LoanDestination } from "../Talentohumano/GestionTH/EmployeeContract/LoanDestination/LoanDestination";
import { AgreementClassification } from "../erp/cellEditor/AgreementClassification/AgreementClassification";
import { BusinessType } from "../erp/cellEditor/BusinessType/BusinessType";
import { RecordType } from "../erp/cellEditor/RecordType/RecordType";
import { RecordProcess } from "../erp/cellEditor/RecordProcess/RecordProcess";
import { ProductLotCatalogByProduct } from "../RemoteAbstractAction/components/com/quickdataerp/actions/steps/ProductLotCatalogByProduct";
import { ProductLotCatalogByProductionOrde } from "../RemoteAbstractAction/components/com/quickdataerp/actions/steps/ProductLotCatalogByProductionOrde";
import { ContractModifyType } from "../erp/ContractModifyType/ContractModifyType";
import { IncomeDocument } from "../Treasury/IncomeDocument/IncomeDocument";
import { IncomeCompensationDocumentReport } from "../Treasury/IncomeCompensationDocumentReport";
import { IncomeResponsible } from "../Factoty&Production/IncomeResponsible/IncomeResponsible";
import { OperationType } from "../erp/cellEditor/OperationType/OperationType";
import { CashFlowConcept } from "../erp/cellEditor/CashFlowConcept/CashFlowConcept";
import { CostingCenterMethod } from "../erp/cellEditor/CostingCenterMethod/CostingCenterMethod";
import { IncomeDocumentResponsible } from "../Treasury/IncomeDocumentResponsible/IncomeDocumentResponsible";
import { EmployeeID } from "../Talentohumano/DigitalID/EmployeeID";
import { RequestSignPanel } from "../bpm/PersonaInbox/RequestSignPanel";
import { PayrollFactor } from "../Talentohumano/ParametrosTalentoHumano/PayrollFactor/PayrollFactor";
import { PayrollType } from "../Talentohumano/ParametrosTalentoHumano/PayrollType/PayrollType";
import { CostStudy } from "../Talentohumano/CostStudy/CostStudy";
import { PriceList } from "../Factoty&Production/PriceList/PriceList";
import { FixedAsset } from "../ManagementFixedAssets/FixedAsset/FixedAsset";
import { FixedAssetItemByEmployee } from "../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/FixedAssetItemByEmployee/FixedAssetItemByEmployee";
import { EmployeesByCostingCenter } from "./configuracion/Fortnight/EmployeesByCostingCenter/EmployeesByCostingCenter";
import { AdquisitionItemPAC } from "../contract/adquisition-setting/AdquisitionItemPAC";
import { ConsolidatePAC } from "../contract/adquisition-setting/ConsolidatePAC/ConsolidatePAC";
import { ReporteDocumentos } from "../contabilidad/bodegaDocumentos/ReporteDocumentos";
import { PayrollLiquidateType } from "../Talentohumano/PayrollLiquidateType/PayrollLiquidateType";
import { PayrollFactorVdos } from "../Talentohumano/ParametrosTalentoHumano/PayrollFactorVdos/PayrollFactorVdos";
import { ChannelType } from "../bpm/config/ChannelType";
import { Approvals } from "../approval/Approvals";
import { MassEmail } from "../contabilidad/bodegaDocumentos/MassEmail";
import { AccountantIDForPayeable } from "../contabilidad/catalogo-cuentas/AccountantTree/AccountantIDForPayeable";
import { FixedAssetItemByChekedReport } from "../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/FixedAssetItemByChekedReport/FixedAssetItemByChekedReport";

import { TaxPosition } from "../bpm/CustomFormNew/CustomForms/Compras/NationalizationProcessGeneralInfo/TaxPosition/TaxPosition";
import { Exportations } from "../bpm/CustomFormNew/CustomForms/Compras/Exportations/Exportations";
import { RetroactiveEmployee } from "../Talentohumano/ParametrosTalentoHumano/RetroactiveEmployee/RetroactiveEmployee";
import { EmploymentType } from "../Talentohumano/GestionTH/EmploymentType/EmploymentType";
import { WelfareEntity } from "../Talentohumano/WelfareEntity/WelfareEntity";
import { AuxLiquidation } from "../bpm/CustomFormNew/CustomForms/Compras/AuxLiquidation/AuxLiquidation";
import { PrintZPLFixedAssetItem } from "../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/PrintPlatesZPL/PrintZPLFixedAssetItem";
import { EmployeeFactorsConsolidated } from "./configuracion/EmployeeFactorsConsolidated/EmployeeFactorsConsolidated";
import { EmployeeContractsWithDefeat } from "../Talentohumano/GestionTH/EmployeeContract/EmployeeContractsWithDefeat";
import { PayrollDocumentType } from "../Talentohumano/ParametrosTalentoHumano/PayrollFactor/PayrollDocumentType/PayrollDocumentType";
import { MatrixImportNationalization } from "../bpm/CustomFormNew/CustomForms/Compras/NationalizationProcessItems/MatrixImportNationalization/MatrixImportNationalization";
import { FixedAssetItemsWithDefeatDates } from "../Talentohumano/GestionTH/EmployeeContract/FixedAssetItemsWithDefeatDates/FixedAssetItemsWithDefeatDates";
import { ByDepreciationValue } from "../Talentohumano/GestionTH/EmployeeContract/ByDepreciationValue/ByDepreciationValue";
import { PhysicalTaking } from "./configuracion/PhysicalTaking/PhysicalTaking";
import { SIIFAuxiliaryType } from "./configuracion/SIIFAuxiliaryType/SIIFAuxiliaryType";
import { SIIFTCON17 } from "./configuracion/SIIFTCON17/SIIFTCON17";
import { SIIFAuxiliaryCatalog } from "./configuracion/SIIFAuxiliaryCatalog/SIIFAuxiliaryCatalog";
import { AssetItemsByOperationState } from "../editor/AssetItemsByOperationState/AssetItemsByOperationState";
import { Report } from "../system/Report/Report";
import { AccountResume } from "../Talentohumano/ParametrosTalentoHumano/AccountResume/AccountResume";
import { ProjectScheduleTask } from "../erp/ProjectSchedule/ProjectScheduleTask";
import { CashDeskAccountByofficecompany } from "../erp/cellEditor/CashDeskAccount/CashDeskAccountByofficecompany/CashDeskAccountByofficecompany";
import { SessionAudit } from "./audit/SessionAudit";
import { PaymentFile } from "../contabilidad/catalogo-cuentas/PaymentFile/PaymentFile";
import { CashReimbursementHistoryfortesoreria } from "../erp/cellEditor/CashDesk/CashReimbursement/CashReimbursementHistoryfortesoreria";
import { CashRequestItemBystate } from "../erp/cellEditor/CashDesk/CashReimbursement/CashRequestItemBystate/CashRequestItemBystate";
import { ConceptCatalogByProcess } from "../Talentohumano/GestionTH/EmployeeContract/ConceptCatalogByProcess/ConceptCatalogByProcess";
import { AccountantCycle } from "../erp/cellEditor/AccountantCycle/AccountantCycle";
import { FinancialTaxPaymentOrder } from "../contract/etapa-contrato/contrac/UBLInvoiceSupplier/Component/UBLInoviceItemSupplier/FinancialTaxPaymentOrder/FinancialTaxPaymentOrder";
import { DocumentFactoryByyear } from "../erp/cellEditor/CashRequest/DocumentFactory/DocumentFactoryByyear";
import { FactoryDocument } from "../erp/cellEditor/CashRequest/FactoryDocument/FactoryDocument";
import { BusinessMovements } from "../erp/cellEditor/BusinessMovements/BusinessMovements";
import { BankingConciliation } from "../contract/adquisition-setting/BankingConciliation/BankingConciliation";
import { BankingStatementMovement } from "../contract/adquisition-setting/BankingStatementMovement/BankingStatementMovement";
import { PaymentTurn } from "../contract/PaymentTurn/PaymentTurn";
import { THConstants } from "../bpm/config/THConstants/THConstants";
import { CashFlow } from "../contract/adquisition-setting/CashFlow/CashFlow";
import { ScheduleProductionOrder } from "../Factoty&Production/ScheduleProductionOrder/ScheduleProductionOrder";
import { TimeEventPending } from "../Factoty&Production/ProductionOrder/Components/TimeEventPending/TimeEventPending";
import { HelpDeskReport } from "./helpdesk/HelpDeskReport";
import { TaskSpecial } from "../Factoty&Production/ProductionOrder/TaskSpecial/TaskSpecial";
import { InterestMora } from "../Talentohumano/ParametrosTalentoHumano/AccountResume/InterestMora/InterestMora";
import { FinishedEmployeeContracts } from "../Talentohumano/GestionTH/EmployeeContract/FinishedEmployeeContracts";
import { TaxHoldValue } from "../Talentohumano/GestionTH/EmployeeContract/TaxHoldValue";
import { PaymentTurnCode } from "../contract/PaymentTurn/PaymentTurnCode/PaymentTurnCode";
import { EmployeeVacProvision } from "../Talentohumano/ParametrosTalentoHumano/EmployeeVacProvision/EmployeeVacProvision";
import { ProcessCycle } from "../Talentohumano/ParametrosTalentoHumano/ProcessCycle/ProcessCycle";
import { OfficialBook } from "../erp/OfficialBook/OfficialBook";
import { DocumentVersionBackupCatalog } from "../contabilidad/bodegaDocumentos/DocumentVersionBackupCatalog/DocumentVersionBackupCatalog";
import { ProductionPlan } from "../Talentohumano/GestionTH/EmployeeContract/ProductionPlan/ProductionPlan";
import { ScheduleEmployeeBonus } from "../Talentohumano/GestionTH/EmployeeContract/ComponentsContract/ScheduleEmployeeBonus/ScheduleEmployeeBonus";
import { ProcessFactoryImp } from "../erp/cellEditor/ProcessFactoryImp/ProcessFactoryImp";
import { IncomeDocumentTalent } from "../Treasury/IncomeDocument/IncomeDocumentTalent";
import { ContributorType } from "../Talentohumano/ParametrosTalentoHumano/ContributorType/ContributorType";
import { EmployeeContractType } from "../Talentohumano/ParametrosTalentoHumano/EmployeeContractType/EmployeeContractType";
import { ContributorSubtype } from "../Talentohumano/ParametrosTalentoHumano/ContributorSubtype/ContributorSubtype";
import { InfoForTaxReporting } from "../Talentohumano/ParametrosTalentoHumano/InfoForTaxReporting/InfoForTaxReporting";
import { InfoForTaxCertificate } from "../Talentohumano/ParametrosTalentoHumano/InfoForTaxCertificate/InfoForTaxCertificate";
import { ElectronicPayroll } from "../Talentohumano/ParametrosTalentoHumano/ElectronicPayroll/ElectronicPayroll";
import { ImportAbstractAccount } from "./CreditPotfolio/ImportBankingAbstractAccount/ImportAbstractAccount";
import { ImportFunctionalArea } from "./configuracion/FunctionalArea/ImportFunctionalArea";
import { PayrollConcepts } from "../Talentohumano/ParametrosTalentoHumano/AccountResume/PayrollConcepts/PayrollConcepts";
import { UblInvoiceCatalog } from "../contabilidad/CatalogoDocumentosUBL/UblInvoiceCatalog";
import { ScheduleProductionOrderForClose } from "../Factoty&Production/ScheduleProductionOrder/ScheduleProductionOrderForClose";
import { ExternalFactory } from "../Factoty&Production/ProductionOrder/ExternalFactory/ExternalFactory";
import { OrderCatalogForExternal } from "../Factoty&Production/ProductionOrder/OrderCatalogForExternal/OrderCatalogForExternal";
import { ProjectInfo } from "../contract/PaymentTurn/ProjectInfo";
import { ProjectProductCrud } from "../erp/AdquisitionProject/ProjectProductCrud/ProjectProductCrud";
import { BankingCheck } from "../contract/adquisition-setting/BankingCheck/BankingCheck";
import { FinancialMovementTax } from "../contract/adquisition-setting/FinancialMovementTax/FinancialMovementTax";
import { BudgetAusterity } from "./configuracion/BudgetAusterity/BudgetAusterity";
import { FinancialMovementTaxTreasure } from "../contract/adquisition-setting/FinancialMovementTax/FinancialMovementTaxTreasure";
import { Kpi } from "../Talentohumano/ParametrosTalentoHumano/Kpi/Kpi";
import { KpiDashBoard } from "../Talentohumano/ParametrosTalentoHumano/KpiDashBoard/KpiDashBoard";
import { FinancialMovementTaxByTicket } from "../contract/adquisition-setting/FinancialMovementTax/FinancialMovementTaxByTicket";
import { AbstractAccountAdminGestionBypaginator } from "../GestionTerceros/AbstractAccount/AbstractAccountAdminGestionBypaginator";
import { TranslateProduct } from "../Talentohumano/ParametrosTalentoHumano/TranslateProduct/TranslateProduct";
import { _single } from "../../core/services/dataBean/EntityCatalog";
import { Kpibycatalog } from "../Talentohumano/ParametrosTalentoHumano/Kpi/Kpibycatalog";
import { KpiDashBoardByAcc } from "../Talentohumano/ParametrosTalentoHumano/KpiDashBoard/KpiDashBoardByAcc";
import { DashBoardAccount } from "../Talentohumano/ParametrosTalentoHumano/KpiDashBoard/DashBoardAccount";
import { FortnightImport } from "../Talentohumano/ParametrosTalentoHumano/FortnightImport/FortnightImport";
import { ActiveItemsHistory } from "../Talentohumano/ParametrosTalentoHumano/ActiveItemsHistory/ActiveItemsHistory";
import { NationalizationProcessGeneralInfo } from "../bpm/CustomFormNew/CustomForms/Compras/NationalizationProcessGeneralInfo/NationalizationProcessGeneralInfobycost";
import { MarketPlace } from "../Inventories-Warehouses/Product/MarketPlace/MarketPlace";
import { SalesOrder } from "../Inventories-Warehouses/Product/SalesOrder/SalesOrder";
import { SalesOrderEvent } from "../Inventories-Warehouses/Product/SalesOrder/SalesOrderEvent/SalesOrderEvent";
import { PortfolioProduct } from "../Inventories-Warehouses/Product/SalesOrder/PortfolioProduct/PortfolioProduct";
import { CommercialCampaign } from "../Inventories-Warehouses/Product/CommercialCampaign/CommercialCampaign";
import { CustomerAddress } from "../Inventories-Warehouses/Product/CustomerAddress/CustomerAddress";
import { DistributionChannel } from "../Inventories-Warehouses/Product/DistributionChannel/DistributionChannel";
import { CustomerTypeTwo } from "../Inventories-Warehouses/Product/CustomerType/CustomerTypeTwo";
import { SalesConsultant } from "../Inventories-Warehouses/Product/SalesConsultant/SalesConsultant";
import { TaxHoldvtwo } from "../Inventories-Warehouses/Product/TaxHold/TaxHoldvtwo";
import { UBLPaymentMeans } from "../Inventories-Warehouses/Product/UBLPaymentMeans/UBLPaymentMeans";
import { UBLPaymentMeansCode } from "../Inventories-Warehouses/Product/UBLPaymentMeansCode/UBLPaymentMeansCode";
import { FreightType } from "../Inventories-Warehouses/Product/FreightType/FreightType";
import { DeliveryTypeTwo } from "../Inventories-Warehouses/Product/DeliveryType/DeliveryTypeTwo";
import { Airport } from "../Inventories-Warehouses/Product/Airport/Airport";
import { AirLine } from "../Inventories-Warehouses/Product/AirLine/AirLine";
import { Agency } from "../Inventories-Warehouses/Product/Agency/Agency";
import { TransportService } from "../Inventories-Warehouses/Product/TransportService/TransportService";
import { TransportDestination } from "../Inventories-Warehouses/Product/TransportDestination/TransportDestination";
import { FreightRate } from "../Inventories-Warehouses/Product/FreightRate/FreightRate";
import { GoodsState } from "../Inventories-Warehouses/Product/GoodsState/GoodsState";
import { GoodsSupport } from "../Inventories-Warehouses/Product/GoodsSupport/GoodsSupport";
import { GoodsType } from "../Inventories-Warehouses/Product/GoodsType/GoodsType";
import { TransportGuide } from "../Inventories-Warehouses/Product/TransportGuide/TransportGuide";
import { Countries } from "../Inventories-Warehouses/Product/Countries/Countries";
import { SelectCountries } from "./configuracion/Countries/SelectCountries";
import { IncidentReport } from "./IncidentReport/IncidentReport";
import { FixedAssetGroups } from "../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/FixedAssetGroups/FixedAssetGroups";
import { FormTypeDinamic } from "../bpm/config/Componentes/FormTypeDinamic/FormTypeDinamic";
import { TraslateBudget } from "../contabilidad/BudgetCDPReductionFactory/TraslateBudget";
import { SocialSecurityTemplate } from "../Talentohumano/ParametrosTalentoHumano/SocialSecurityTemplate/SocialSecurityTemplate";
import { SocialSecuritySpreadSheet } from "../Talentohumano/ParametrosTalentoHumano/SocialSecuritySpreadSheet/SocialSecuritySpreadSheet";
import { TransportRoute } from "../Inventories-Warehouses/Product/TransportRoute/TransportRoute";
import { PriceListFreightRate } from "../Inventories-Warehouses/Product/FreightRate/PriceListFreightRate/PriceListFreightRate";
import { Dashed } from "../pages/DefaultHomePage/Dashed/Dashed";
import { Calendar } from "../pages/DefaultHomePage/Dashed/components/CalendarDashed/Calendar";
import { DefaultHome } from "../pages/DefaultHomePage/DefaultHome";
import { OfficeNew } from "../Talentohumano/GestionTH/EmployeeContract/Office/OfficeNew";
import { CargoManifest } from "../Inventories-Warehouses/Product/CargoManifest/CargoManifest";
import { TeamGroupMembers } from "./configuracion/functionalID/TeamGroupMembers/TeamGroupMembers";
import { SSTPeriod } from "../Talentohumano/ParametrosTalentoHumano/SSTPeriod/SSTPeriod";
import { TransportGuideLiquidator } from "../Inventories-Warehouses/Product/TransportGuideLiquidator/TransportGuideLiquidator";
import { Aircraft } from "../Inventories-Warehouses/Product/Aircraft/Aircraft";
import { PriceTransportGuide } from "../Inventories-Warehouses/Product/PriceTransporGuide/PriceTransportGuide";
import { CurrentFlights } from "../Inventories-Warehouses/Product/CurrentFlights/CurrentFlights";
import { Provision } from "../Talentohumano/ParametrosTalentoHumano/Provision/Provision";
import { SIIFTCON6Value } from "../Talentohumano/ParametrosTalentoHumano/SIIFTCON6Value/SIIFTCON6Value";
import { ProvisionData } from "../Talentohumano/ParametrosTalentoHumano/Provision/ProvisionData";
import { HiringModalityStage } from "../contract/HiringModalityStage/HiringModalityStage";
import { HealthIDType } from "../Talentohumano/ParametrosTalentoHumano/HealthIDType/HealthIDType";
import { HealthIDStructure } from "../Talentohumano/ParametrosTalentoHumano/HealthIDStructure/HealthIDStructure";
import { HealthID } from "./configuracion/HealthID/HealthID";
import { PharmaRecordState } from "../Talentohumano/ParametrosTalentoHumano/HealthMedication/PharmaRecordState/PharmaRecordState";
import { PharmaLaboratory } from "../Talentohumano/ParametrosTalentoHumano/HealthMedication/PharmaLaboratory/PharmaLaboratory";
import { PharmaCumState } from "../Talentohumano/ParametrosTalentoHumano/HealthMedication/PharmaCumState/PharmaCumState";
import { MeansAdministration } from "../Talentohumano/ParametrosTalentoHumano/HealthMedication/MeansAdministration/MeansAdministration";
import { PharmaPresentation } from "../Talentohumano/ParametrosTalentoHumano/HealthMedication/PharmaPresentation/PharmaPresentation";
import { HealthMedication } from "../Talentohumano/ParametrosTalentoHumano/HealthMedication/HealthMedication";
import { HealthEntity } from "./configuracion/HealthID/HealthEntity/HealthEntity";
import { HealthScope } from "../Talentohumano/ParametrosTalentoHumano/HealthMedication/HealthScope/HealthScope";
import { HealthContractType } from "../Talentohumano/ParametrosTalentoHumano/HealthMedication/HealthContractType/HealthContractType";
import { HealthContract } from "../Talentohumano/ParametrosTalentoHumano/HealthMedication/HealthContract/HealthContract";
import { BudgetProduct } from "../Talentohumano/ParametrosTalentoHumano/BudgetProduct/BudgetProduct";
import { BudgetActivity } from "../Talentohumano/ParametrosTalentoHumano/BudgetActivity/BudgetActivity";
import { ClinicalDocument } from "../Talentohumano/ParametrosTalentoHumano/HealthMedication/ClinicalDocument/ClinicalDocument";
import { RelationshipType } from "../Talentohumano/ParametrosTalentoHumano/RelationshipType/RelationshipType";
import { PopulationType } from "../Talentohumano/ParametrosTalentoHumano/PopulationType/PopulationType";
import { SexType } from "../Talentohumano/ParametrosTalentoHumano/SexType/SexType";
import { SiteType } from "../Inventories-Warehouses/Product/SiteType/SiteType";
import { HealthDisabilityType } from "../Inventories-Warehouses/Product/HealthDisabilityType/HealthDisabilityType";
import { HealthRegimen } from "../GestionTerceros/AbstractAccount/HealthRegimen/HealthRegimen";
import { EthnicGroup } from "../Talentohumano/ParametrosTalentoHumano/EthnicGroup/EthnicGroup";
import { HealthAttentionModality } from "../GestionTerceros/AbstractAccount/HealthAttentionModality/HealthAttentionModality";
import { HealthAttentionService } from "../GestionTerceros/AbstractAccount/HealthAttentionService/HealthAttentionService";
import { HealthAttentionGateEntry } from "../GestionTerceros/AbstractAccount/HealthAttentionGateEntry/HealthAttentionGateEntry";
import { HealthAttentionSite } from "../GestionTerceros/AbstractAccount/HealthAttentionSite/HealthAttentionSite";
import { HealthAttentionCause } from "../GestionTerceros/AbstractAccount/HealthAttentionCause/HealthAttentionCause";
import { TriageType } from "../GestionTerceros/AbstractAccount/TriageType/TriageType";
import { HealthTechnologyType } from "../GestionTerceros/AbstractAccount/HealthTechnologyType/HealthTechnologyType";
import { HealthTechnologyPurpose } from "../GestionTerceros/AbstractAccount/HealthTechnologyPurpose/HealthTechnologyPurpose";
import { HealthTimeUnit } from "../GestionTerceros/AbstractAccount/HealthTimeUnit/HealthTimeUnit";
import { PatientDischargeStatus } from "../GestionTerceros/AbstractAccount/PatientDischargeStatus/PatientDischargeStatus";
import { HealthAllergies } from "../GestionTerceros/AbstractAccount/HealthAllergies/HealthAllergies";
import { RiskFactoryType } from "../../core/services/dataBean/talentoHumano/cofigpresupuestoycompras/RiskFactoryType";
import { RiskType } from "../GestionTerceros/AbstractAccount/RiskType/RiskType";
import { IncapacityType } from "../GestionTerceros/AbstractAccount/IncapacityType/IncapacityType";
import { HealthDiagnosisType } from "../GestionTerceros/AbstractAccount/HealthDiagnosisType/HealthDiagnosisType";
import { HealthOrphanDisease } from "../GestionTerceros/AbstractAccount/HealthOrphanDisease/HealthOrphanDisease";
import { BodyComponent } from "../GestionTerceros/AbstractAccount/BodyComponent/BodyComponent";
import { HealthProduct } from "../GestionTerceros/AbstractAccount/HealthProduct/HealthProduct";
import { HealthAssesmentResult } from "../GestionTerceros/AbstractAccount/HealthAssesmentResult/HealthAssesmentResult";
import { HealthLOINC } from "../GestionTerceros/AbstractAccount/HealthLOINC/HealthLOINC";
import { MedicalDevice } from "../GestionTerceros/AbstractAccount/MedicalDevice/MedicalDevice";
import { ProcessPropertiesItem } from "./ProcessPropertiesItem/ProcessPropertiesItem";


export const RouterAdmin = (props: any) => {

  const { module, view, param, atribute }: any = useParams();

  const renderSwitch = (url: string) => {
    switch (url) {
      case "perfil":
        return <Dashed />;
      case "user-inbox":
        return <PerosnalInbox />;
      case "calendar":
        return <Calendar />;
      case "dashBoard":
        return <DashBoardAccount />;
      case "admin-inbox":
        return <PerosnalInbox admin />;
      case "request-sing":
        return <RequestSignPanel />;
      case "catalogo-activos-estado":
        return <AssetItemsByOperationState />;
      case "compensacion-servicios-financieros":
        return <ConceptCatalogByProcess />;
      case "ordenes-gravamenes":
        return <FinancialTaxPaymentOrder />;
      case "extractos-bancarios":
        return <BankingStatementMovement />;
      case "cierres-contables":
        return <AccountantCycle />;
      case "conciliacion-bancaria":
        return <BankingConciliation />;
      case "legalizar-facturas":
        return <CashRequestItemBystate />;
      case "catalogo-auxiliares":
        return <SIIFAuxiliaryCatalog />;
      case "consecutivos-fabricas-doc":
        return <DocumentFactoryByyear />;
      case "fabricas-documentos":
        return <FactoryDocument />;
      case "actualizar-unidad-negocio":
        return <BusinessMovements />;
      case "turnos-pago-cuentas":
        return <PaymentTurn />;
      case "hoja-vida":
        return <AccountResume />;
      case "desembolsar-caja":
        return <CashDeskAccountByofficecompany />;
      case "alertas-dias-vencidos":
        return <EmployeeContractsWithDefeat />;
      case "toma-fisica":
        return <PhysicalTaking />;
      case "tipos-auxiliar":
        return <SIIFAuxiliaryType />;
      case "auxiliares-tcon":
        return <SIIFTCON17 />;
      case "alertas-activos":
        return <ByDepreciationValue />;
      case "anticipos-vacaciones":
        return <EmployeeVacProvision />;
      case "plan-maestro":
        return <ProductionPlan />;
      case "reporte-facturas-venta":
        return <UblInvoiceCatalog />;
      case "ordenes-para-cierre":
        return <ScheduleProductionOrderForClose />;
      case "maquilas-centros-externos":
        return <ExternalFactory />;
      case "informe-proyectos":
        return <ProjectInfo />;
      case "ordenes-prod-maquila":
        return <OrderCatalogForExternal />
      case "tipo-cotizante":
        return <ContributorType />;
      case "sub-tipo-cotizante":
        return <ContributorSubtype />;
      case "estructura-exogena":
        return <InfoForTaxReporting />;
      case "estructura-ingresos-retenciones":
        return <InfoForTaxCertificate />;
      case "conceptos-nomina-electronica":
        return <ElectronicPayroll />;
      case "conceptos-por-payroll":
        return <PayrollConcepts />;
      case "tipos-contratos-laborales":
        return <EmployeeContractType />;
      case "definicion-precios":
        return <ProjectProductCrud />;
      case "beneficiones-temporales":
        return <ScheduleEmployeeBonus />;
      case "cierre-procesos":
        return <ProcessCycle />;
      case "config-subprocesos":
        return <ProcessFactoryImp />;
      case "compensacion-talento-humano":
        return <IncomeDocumentTalent />;
      case "libros-oficiales-contabilidad":
        return <OfficialBook />;
      case "eventos-notificicaciones":
        return <DocumentVersionBackupCatalog />;
      case "reporte-proviciones":
        return <Provision />;
      case "solicitudes-obligaciones-gastos":
        return <FinancialMovementTaxByTicket />;
      case "tiempos-contabilizar":
        return <TimeEventPending />;
      case "tareas-especiales-orden":
        return <TaskSpecial />;
      case "aux-cont":
        return <SIIFTCON6Value />;
      case "prov-data-nuevo":
        return <ProvisionData />;
      case "interes-mora":
        return <InterestMora />;
      case "reporte-contratos-terminados":
        return <FinishedEmployeeContracts />;
      case "retencion-fuente-empleado":
        return <TaxHoldValue />;
      case "config-tareas":
        return <PaymentTurnCode />;
      case "formas-pago":
        return <UBLPaymentMeans />;
      case "medios-pago":
        return <UBLPaymentMeansCode />;
      case "liquidacion-guias":
        return <TransportGuideLiquidator />;
      case "formatos-seguridad-social":
        return <SocialSecurityTemplate />;
      case "tipos-carga":
        return <FreightType />;
      case "tipos-envio":
        return <DeliveryTypeTwo />;
      case "aeropuertos":
        return <Airport />;
      case "aerolinea":
        return <AirLine />;
      case "aeronaves":
        return <Aircraft />;
      case "agencias":
        return <Agency />;
      case "servicios-transporte":
        return <TransportService />;
      case "destinos-transporte":
        return <TransportDestination />;
      case "tarif-carga":
        return <PriceListFreightRate />;
      case "planillas-seguridad-social":
        return <SocialSecuritySpreadSheet />;
      case "rutas-transporte":
        return <TransportRoute />;
      case "oficina-nueva":
        return <OfficeNew />;
      case "estado-carga":
        return <GoodsState />;
      case "soportes-carga":
        return <GoodsSupport />;
      case "tipos-bienes":
        return <GoodsType />;
      case "guias-transporte":
        return <TransportGuide />;
      case "cotizacion-guias-transporte":
        return <PriceTransportGuide />;
      case "manifiestos-carga":
        return <CargoManifest />;
      case "vuelos-disponibles":
        return <CurrentFlights />;
      case "paises-estados":
        return <Countries />;
      case "tipos-documentos-laborales":
        return <PayrollDocumentType />;
      case "activos-responable":
        return <FixedAssetItemByEmployee />;
      case "alertas-activos-fijos":
        return <FixedAssetItemsWithDefeatDates />;
      case "miscursos":
        return <Miscursos />;
      case "reporte-flujo":
        return <CashFlow />;
      case "concep-rete-emple":
        return <TaxHoldvtwo />;
      case "cronograma-orden":
        return <ScheduleProductionOrder />;
      case "factores-nomina":
        return <PayrollFactorVdos />;
      case "lista-precios":
        return <PriceList />;
      case "catalogo-activos-fijos-controlados":
        return <FixedAssetItemByChekedReport />;
      case "hisorico-cambios-factores-salarial":
        return <EmployeeFactorsConsolidated />;
      case "info-general-estudio-costos":
        return <NationalizationProcessGeneralInfo />;
      case "porcentaje-arancel":
        return <TaxPosition />;
      case "costo-estudio":
        return <CostStudy />;
      case "digital-id":
        return <EmployeeID />;
      case "canal-distribucion":
        return <ChannelType />;
      case "empleado-centrocosto":
        return <EmployeesByCostingCenter />;
      case "configuracion-payroll":
        return <PayrollFactor />;
      case "tipo-payroll":
        return <PayrollType />;
      case "curso":
        return <TabsCourse />
      case "responsables-detalle-ingreso":
        return <IncomeResponsible />
      case "flujo-caja":
        return <CashFlowConcept />
      case "menu":
        return <MenuUsuario />;
      case "tipo-operacion":
        return <OperationType />;
      case "perfil-usuario":
        return <SystemRoles />;
      case "destino-credito":
        return <LoanDestination />;
      case "modelos-costeo":
        return <CostingCenterMethod />;
      case "roles-group":
        return <RoleGroup />;
      case "tipos-modificaciones":
        return <ContractModifyType />;
      case "clasificacion-convenio":
        return <AgreementClassification />;
      case "tipo-negocio":
        return <BusinessType />;
      case "lote-producto":
        return <ProductLotCatalogByProduct />;
      case "lote-producto-orden-produccion":
        return <ProductLotCatalogByProductionOrde />;
      case "roles-area":
        return <RoleArea />;
      case "funcionarios-area":
        return <TeamGroupMembers />;
      case "funcionarios-are-plazas":
        return <EmployeeContractByIDLN role="BossArea" />;
      case "cretificado-digital":
        return <Certificate />;
      case "software-project":
        return <Projects />;
      case "expediente-catalogo":
        return <RecordProcess />;
      case "etapas-devops":
        return <StepDevops />;
      case "certificado-disponibilidad":
        // return <BudgetCDPFactory />
        return <BudgetCDPFactory modal={false} />
      case "rol-devops":
        return <RolDevops />;
      case "usuario-proyecto":
        return <AccountProject />;
      case "configurar-proceso":
        return <Process />;
      case "reporte-pagomasivo":
        return <PaymentHeader />;
      case "historia-proyecto":
        return <History />;
      case "flujo-contrato":
        return <RequestTypeBpm />
      case "roles-proceso":
        return <ContractRole />;
      case "budget-structure":
        return <BudgetStructure />;
      case "budget-idtype":
        return <BudgetIDType />;
      case "tipo-documento":
        return <DocumentType />;
      case "budget-type":
        return <BudgetType />;
      case "class-bienoservicio":
        return <ArticleClassType />;
      case "proyectos":
        return <AdquisitionProject />;
      case "cheques-bancarios":
        return <BankingCheck />;
      case "catalogo-consolidar":
        return <TypeNeed />;
      case "software-facturacion":
        return <UBLSoftwareDispatcher />
      case "market-place":
        return <MarketPlace />
      case "gestion-clientes":
        return <SalesOrder />
      case "eventos-oportunidades-venta":
        return <SalesOrderEvent />
      case "producto-portafolio":
        return <PortfolioProduct />
      case "camp-comerciales":
        return <CommercialCampaign />
      case "direcciones-comerciales":
        return <CustomerAddress />
      case "canales-distribucion":
        return <DistributionChannel />
      case "segmentacion-clientes":
        return <CustomerTypeTwo />
      case "consultores-venta":
        return <SalesConsultant />
      case "metodos-pago":
        return <PaymentMethod />;
      case "measurement-unit":
        return <MeasurementUnit />;
      case "importar-factor-salarial":
        return <FortnightImport />;
      case "importar-historico-items":
        return <ActiveItemsHistory />;
      case "requisitos-pago":
        return <PaymentRequirement />;
      case "generar-obligaciones-gastos":
        return <FinancialMovementTax />;
      case "generar-notas-debito-gastos":
        return <FinancialMovementTaxTreasure />;
      case "catalogo-kpi":
        return <Kpi />;
      case "catalogo-kpi-catalog":
        return <Kpibycatalog />;
      case "catalogo-kpi-acc":
        return <KpiDashBoardByAcc />;
      case "tab-control":
        return <KpiDashBoard />;
      case "tipo-expediente":
        return <RecordType />
      case "tipo-contratacion":
        return <ContractType />
      case "delivery-type":
        return <DeliveryType />;
      case "cuentas-pagar":
        return <PaymentAccount />;
      case "comprobantes-ingreso":
        return <IncomeDocument />;
      case "comprobantes-ingreso-compensacion":
        return <IncomeDocumentResponsible />;
      case "historialdetramite":
        return <Historialdetramite />;
      case "componentes":
        return <Components />;
      case "matriz-trazabilidad":
        return <MatrizSeguimiento />;
      case "third-party-user":
        return <ThirdPartyUser />;
      case "afiliate":
        return <Afiliate />;
      case "segmento-contable":
        return <BudgetAccountantID />;
      case "functional-area":
        return <FunctionalArea />;
      case "roles-en-area":
        return <RolesenArea />;
      case "importar-cuenta-banco":
        return <ImportBankingAccount />;
      case "functionalid":
        return (
          <BasicPage titulo="Estructura Organizacional">
            <FunctionalID id={null} edit={true} />
          </BasicPage>
        );
      case "projectid":
        return (
          <BasicPage titulo="Catálogo de Iniciativas Estratégicas">
            <ProjectID id={null} edit={true} />
          </BasicPage>
        );
      case "unspscid":
        return (
          <BasicPage titulo="Árbol Clasificador de Bienes y Servicios Unspsc">
            <UnspscID id={null} edit={true} />
          </BasicPage>
        );
      case "trdid":
        return (
          <BasicPage titulo="Tabla de Retenciones TRD">
            <TrdID id={null} edit={true} />
          </BasicPage>
        );

      case "budgetid":
        return (
          <BasicPage titulo="Catálogo de Rubros Presupuestales">
            <BudgetID tipoPresupuesto={null} id={null} edit={true} />
          </BasicPage>
        );
      case "budgetid-health":
        return (
          <BasicPage titulo="Catálogo de Códigos de Clasificación de Productos y Servicios">
            <HealthID crud={true} tipoPresupuesto={null} id={null} edit={true} />
          </BasicPage>
        );
      case "apimodule":
        return <ApiModule />;
      case "tipos-ubicacion":
        return <SiteType />;
      case "regimen-salud":
        return <HealthRegimen />;
      case "modalidades-atencion":
        return <HealthAttentionModality />;
      case "servicios-atencion":
        return <HealthAttentionService />;
      case "sitios-atencion":
        return <HealthAttentionSite />;
      case "puertas-atencion":
        return <HealthAttentionGateEntry />;
      case "causa-atencion":
        return <HealthAttentionCause />;
      case "tipos-triage":
        return <TriageType />;
      case "tipos-tecnologias-salud":
        return <HealthTechnologyType />;
      case "propositos-atencion":
        return <HealthTechnologyPurpose />;
      case "unidades-tiempo":
        return <HealthTimeUnit />;
      case "estado-salida":
        return <PatientDischargeStatus />;
      case "tipos-alergias":
        return <HealthAllergies />;
      case "tipos-factor":
        return <RiskType />;
      case "tipos-de-incapacidad":
        return <IncapacityType />;
      case "tipos-diagnostico":
        return <HealthDiagnosisType />;
      case "tipos-diagnostico":
        return <HealthDiagnosisType />;
      case "enfemedades-huerfanas":
        return <HealthOrphanDisease />;
      case "componentes-cuerpo":
        return <BodyComponent />;
      case "catalogo-loinc":
        return <HealthLOINC />;
      case "dispositivos-medicos":
        return <MedicalDevice />;
      case "producto-salud":
        return <HealthProduct />;
      case "resultados-valoracion":
        return <HealthAssesmentResult />;
      case "productos-presupuesto":
        return <BudgetProduct />;
      case "tipo-relacion":
        return <RelationshipType />;
      case "tipo-poblacion":
        return <PopulationType />;
      case "tipo-sexualidad":
        return <SexType />;
      case "grupo-etnico":
        return <EthnicGroup />;
      case "historia-clinica":
        return <ClinicalDocument />;
      case "actividades-presupuesto":
        return <BudgetActivity />;
      case "entidades-prestadoras":
        return <HealthEntity />;
      case "ambito-atencion":
        return <HealthScope />;
      case "contratos-servicios-tecnologia":
        return <HealthContract />;
      case "contratos-atencion":
        return <HealthContractType />;
      case "catalogo-medicamentos":
        return <HealthMedication />;
      case "estado-registro-medicamentos":
        return <PharmaRecordState />;
      case "laboratorios-farmaceuticos":
        return <PharmaLaboratory />;
      case "cum-registro-medicamentos":
        return <PharmaCumState />;
      case "administracion-medicamentos":
        return <MeansAdministration />;
      case "presentacion-medicamentos":
        return <PharmaPresentation />;
      case "api-role":
        return <ApiRole />;
      case "requirement-type":
        return <RequirementType />;
      case "hiring-modality-document":
        return <HiringModalityDocument />;
      case "hiring-modality-stage":
        return <HiringModalityStage />;
      case "systempropertie":
        return <SystemPropertie />;
      case "abstractaccounts":
        return <AbstractAccount />;
      case "structuring-document":
        return <StructuringDocument />;
      case "codigos-clasificacion":
        return <TaxCodeAccount />;
      // case "cuenta-tercero-gestion":
      //   return <AbstractAccountAdminGestion />;
      case "cuenta-tercero-gestion":
        return <AbstractAccountAdminGestionBypaginator />;
      case "conceptos-costos-gastos-consumo":
        return <TranslateProduct />;
      case "cuentas-terceros":
        return <ThirdBankingAccount />;
      case "auditoria":
        return <Auditorianueva />;
      case "audit":
        return <AuditLog />;
      case "encrypt-file":
        return <PgpEncrypt />;
      case "salary-inquiry":
        return <SalaryInquiry />;
      case "responsabilidad-fiscal":
        return <FiscalResponsability />;
      case "suppConstants":
        return <SuppConstants />;
      case "requirement-sst":
        return <RequirementSST />;
      case "formatos":
        return <Formatos />;
      case "Matrizdefactores":
        return <FactorMatrix />;
      case "sqlerrors":
        return <ErrorsSql />;
      case "bandeja-mensajes":
        return <VisualBandeja />;
      case "matrizriesgos":
        return <Matrizriesgos />;
      case "doc-supplier-config":
        return <DocSupplierConfig />;
      case "mis-aprobaciones":
        return <MisApprovals />;
      case "aprobaciones":
        return <Approvals />;
      case "formularios-dinamicos":
        return <FormTypeDinamic />;
      case "reporte-nacionalizacion":
        return <MatrixImportNationalization />;
      case "festivos":
        return <FestiveDay />;
      case "generic-editor-erp":
        return <GenericCellEditor />;
      case "apoyo-educativo":
        return <EducationalSupport />;
      case "disfrute-vacaciones":
        return <EnjoyedVacationERP rol={1} />;
      case "monitor-almacen":
        return <ReaderUHF />;
      case "siteid":
        return <SelectCountries />
      case "app-quicdata-erp":
        return <ApplicationGroup />;
      case "grupos":
        return <BasicPage titulo="Ciudades"> </BasicPage>;
      case "plantilla-documento":
        return <DocumentTemplate />;
      case "export-menu":
        return <ExportMenu />;
      case "group-template":
        return <GroupTemplate />;
      case "catalogo-compania":
        return <Company />;
      case "migrar-plazas":
        return <FunctionalAreaVdos />;
      case "reembolsos-cajamenor":
        return <CashReimbursementHistoryfortesoreria />;
      case "unidades-medida":
        return <MeasurementUnitCode />;
      case "seguridad-social-entidad":
        return <WelfareEntity />;
      case "empleados-retroactividad":
        return <RetroactiveEmployee />;
      case "tipos-empleados":
        return <EmploymentType />;
      case "auxiliar-liquidacion":
        return <AuxLiquidation />;
      case "exportaciones":
        return <Exportations />;
      case "subproceso-quick":
        return <CustomProcessType />;
      case "centro-costo":
        return <CostingCenter />;
      case "pdf-libreria":
        return <PdfLibraryFactory />
      case "cuentas-proceso":
        return <AccountantIDForPayeable />
      case "rembolsos-cajas":
        return <CashReimbursementHistory menuComponent />;
      case "cuentas-banco":
        return <BankAccountCatalog />;
      case "entidad-fianciera":
        return <BankingEntity />;
      case "tipos-pagos":
        return <PaymentType />;
      case "procesos-liquidacion-nomina":
        return <PayrollLiquidateType />;
      case "codigos-salud":
        return <HealthIDType />
      case "estructura-codigos-salud":
        return <HealthIDStructure />
      case "cuentas-cajamenor":
        return <PaymentAccount CASH_REIMBURSEMENT={15} />;
      case "cajas-menores":
        return <CashDeskAccount />;
      case "catalogo-libros":
        return <AccountantBook />;
      case 'catalogo-conceptoscontables':
        return <AccountantConcept />;
      case "catalogo-oficinas":
        return <Office />;
      case "catalogo-servicios-contable-presupuestales":
        return <BudgetAccountantOperation />;
      case "catalogo-core-negocio":
        return <BusinessCore />;
      case "conceptos-caja":
        return <CashReimbursementConcept />;
      case "catalogo-monedas":
        return <Currency />;
      case "inbox-cash":
        return <InboxCash />;
      case "tipos-esquemas-impuestos":
        return <TaxSchemeContext />;
      case "tipos-codigos-clasificacion-impuestos":
        return <TaxCodeScheme />;
      case "codigos-clasificacion-impuestos":
        return <TaxCode />;
      case "Codigos-actividad-impuestos":
        return <UBLTaxSchemeContextCode />;
      case "tipos-impuestos":
        return <TaxScheme />;
      case "simulador-retenciones":
        return <TaxSchemeSimulator menuComponent />;
      case "formularios-quick":
        return <FormType />;
      case "fuentes-financimiento":
        return <BudgetSource />;
      case "fiscal-responsabilidad":
        return <FiscalResponsability />
      case "responsabilidad-fiscal-type":
        return <FiscalResponsabilityType />
      case "catalogo-cuentas-contrables":
        return <AccountantIDType />;
      case "importar-cuentas-contables-catalogo-presupuestal":
        return <ImportarCuentasContables />;
      case "exportar-cuentas-contables-catalogo-presupuestal":
        return <ExportarCuentasContables />
      case "plan-cuentas-contable":
        return <BasicPage titulo="Plan de Cuentas Contables">
          <AccountantTree edit={true} id={view} />
          </BasicPage> 
      case "catalogo-clasificacion-bienes":
        return <ArticleClassCodeTree edit={true} id={view} />
      case "tipo-recursos":
        return <BudgetResource />
      case "solicitud-pago-cajamenor":
        return <CashRequest />
      case "solicitudes-recibidas-cajas":
        return <ManageCahsRequest />
      case "traslado-presupuesto":
        return <TraslateBudget />
      case "registro-presupuestal":
        return <BudgetRPFactory />
      case "certificados-cdp":
        return <CashDeskAccountCDP />
      case "credito-rubros-presupuestales":
        return <BudgetMovementFactory />
      case "reduccion-registro-presupuestal":
        return <BudgetReductionRPFactory />
      case "presupuesto-inicial":
        return <BudgetSheetFactory />
      case "adicion-presupuestal":
        return <BudgetAdditionFactory />
      case "reduccion-presupuestal":
        return <BudgetReductionFactory />
      case "cdp-reductionfactory":
        return <BudgetCDPReductionFactory />
      case "configurar-segmentocontable":
        return <BudgetCDPReductionFactory />
      case "obligacion-presupuestal":
        return <BudgetObligationFactory />
      case "bodega-documentos":
        return <BodegaDocumentos />
      case "reporte-documentos":
        return <ReporteDocumentos />
      case "reporte-compensaciones":
        return <IncomeCompensationDocumentReport />
      case "email-masivo":
        return <MassEmail />
      case "ver-firmas":
        return <SignAndApprovalPanel />
      case "catalogo-documentos-ubl":
        return <UBLDocumentCatalog />
      case "dodo-docs":
        return <DodoPanel />
      case "catalogo-activos-fijos":
        return <FixedAsset />
      case "pac":
        return <AdquisitionItemPAC />
      case "paleacion-pac":
        return <ConsolidatePAC />
      case "impresion-placas-zpl":
        return <PrintZPLFixedAssetItem />
      case "esquemas-reportes-contables":
        return <Report />
      case "schedule-project":
        return <ProjectScheduleTask asView={false} />
      case "report-task-project":
        return <ProjectScheduleTask asView={true} />
      case "session-report":
        return <SessionAudit />
      case "tipos-archivos-pagos-cuentas":
        return <PaymentFile />
      case "periodo-sstp":
        return <SSTPeriod />
      case "module-properties":
        return <BasicPage titulo={`Propiedades del Módulo ${param}`}>
          <SystemPropertie appName={param} />
        </BasicPage>
      case 'parametricas-sistema':
        return <THConstants />
      case 'parametricas':
        return <THConstants appName={param} />
      case 'helpdesk-report':
        return <HelpDeskReport />
      case "importar-terceros":
        return <ImportAbstractAccount />;
      case "importar-talento-humano":
        return <ImportFunctionalArea />;
      case "rubro-austeridad":
        return <BudgetAusterity />;
      case "soporte-erp":
        return <IncidentReport />;
      case "grupos-activos":
        return <FixedAssetGroups />;

      case "propiedades-proceso":
        return <ProcessPropertiesItem />;

      case "admin-soporte-erp":
        return <IncidentReport adminMenu />;
      default:
        return <DefaultHome />;
    }
  };

  return (
    <>
      {renderSwitch(view)}
    </>
  )
};
